import React from 'react';
import { Logo } from './Logo';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

export const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="border-b border-[rgba(0,0,0,0.1)] py-4">
        <div className="container flex items-center justify-between">
          <Link to="/">
            <Logo size="small" />
          </Link>
          <Link to="/" className="flex items-center gap-2 text-[rgb(131,146,140)] hover:text-[rgb(0,55,32)] transition-colors">
            <ArrowLeft size={18} />
            <span>Torna alla Home</span>
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="container py-12 max-w-4xl">
        <h1 className="heading-1 mb-8">Termini di Servizio</h1>
        <p className="text-[rgb(131,146,140)] mb-8">Ultimo aggiornamento: Gennaio 2025</p>

        <div className="prose prose-lg max-w-none text-[rgb(14,15,12)]">
          <section className="mb-8">
            <h2 className="heading-3 mb-4">1. Accettazione dei Termini</h2>
            <p className="body-medium text-[rgb(131,146,140)] mb-4">
              Utilizzando l'applicazione EZVI e il sito web ezvi.it, accetti di essere vincolato da questi 
              Termini di Servizio. Se non accetti questi termini, ti preghiamo di non utilizzare i nostri servizi.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="heading-3 mb-4">2. Descrizione del Servizio</h2>
            <p className="body-medium text-[rgb(131,146,140)] mb-4">
              EZVI è un servizio di confronto prezzi per colonnine di ricarica per veicoli elettrici. 
              Il servizio:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-[rgb(131,146,140)]">
              <li>Aggrega informazioni sui prezzi da vari operatori</li>
              <li>Non gestisce direttamente le colonnine di ricarica</li>
              <li>Non effettua transazioni di pagamento per le ricariche</li>
              <li>Fornisce informazioni a scopo informativo</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="heading-3 mb-4">3. Utilizzo del Servizio</h2>
            <p className="body-medium text-[rgb(131,146,140)] mb-4">Ti impegni a:</p>
            <ul className="list-disc pl-6 space-y-2 text-[rgb(131,146,140)]">
              <li>Utilizzare il servizio solo per scopi leciti</li>
              <li>Non tentare di accedere a sistemi o dati non autorizzati</li>
              <li>Non interferire con il funzionamento del servizio</li>
              <li>Non utilizzare sistemi automatizzati per estrarre dati</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="heading-3 mb-4">4. Accuratezza delle Informazioni</h2>
            <p className="body-medium text-[rgb(131,146,140)] mb-4">
              Ci impegniamo a fornire informazioni accurate sui prezzi, ma:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-[rgb(131,146,140)]">
              <li>I prezzi possono variare senza preavviso</li>
              <li>La disponibilità delle colonnine può cambiare in tempo reale</li>
              <li>Consigliamo sempre di verificare i prezzi con l'operatore prima della ricarica</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="heading-3 mb-4">5. Limitazione di Responsabilità</h2>
            <p className="body-medium text-[rgb(131,146,140)] mb-4">
              EZVI non è responsabile per:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-[rgb(131,146,140)]">
              <li>Eventuali discrepanze nei prezzi visualizzati</li>
              <li>Malfunzionamenti delle colonnine degli operatori terzi</li>
              <li>Perdite derivanti dall'utilizzo delle informazioni fornite</li>
              <li>Interruzioni del servizio</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="heading-3 mb-4">6. Proprietà Intellettuale</h2>
            <p className="body-medium text-[rgb(131,146,140)] mb-4">
              Tutti i contenuti, marchi e materiali presenti su EZVI sono di proprietà della Società 
              o dei rispettivi titolari e sono protetti dalle leggi sul diritto d'autore.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="heading-3 mb-4">7. Modifiche ai Termini</h2>
            <p className="body-medium text-[rgb(131,146,140)] mb-4">
              Ci riserviamo il diritto di modificare questi termini in qualsiasi momento. 
              Le modifiche saranno pubblicate su questa pagina con la data di aggiornamento.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="heading-3 mb-4">8. Legge Applicabile</h2>
            <p className="body-medium text-[rgb(131,146,140)] mb-4">
              Questi Termini sono regolati dalla legge italiana. Per qualsiasi controversia sarà 
              competente il Foro di Milano.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="heading-3 mb-4">9. Contatti</h2>
            <p className="body-medium text-[rgb(131,146,140)] mb-4">
              Per domande sui Termini di Servizio: 
              <a href="mailto:legal@ezvi.it" className="text-[rgb(13,121,22)] hover:underline">legal@ezvi.it</a>
            </p>
          </section>
        </div>
      </main>
    </div>
  );
};

export default TermsOfService;
